import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { useDeleteTripItem } from "@/hooks/useTrips";
import { toast } from "sonner";

interface DeleteItemDialogProps {
  tripId: string;
  itemType: "flights" | "hotels" | "cars" | "activities" | "cruises";
  index: number;
  itemName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const DeleteItemDialog = ({
  tripId,
  itemType,
  index,
  itemName,
  open,
  onOpenChange,
}: DeleteItemDialogProps) => {
  const deleteItem = useDeleteTripItem();

  const handleDelete = () => {
    deleteItem.mutate(
      { tripId, itemType, index },
      {
        onSuccess: () => {
          toast.success(`${itemName} deleted`);
          onOpenChange(false);
        },
        onError: (error) => {
          toast.error(`Failed to delete: ${error.message}`);
        },
      }
    );
  };

  const itemTypeLabel = {
    flights: "flight",
    hotels: "hotel",
    cars: "car rental",
    activities: "activity",
    cruises: "cruise",
  }[itemType];

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {itemTypeLabel}?</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete "{itemName}"? This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
